import { API_CONFIG } from '../staticDataConfig';
import { TemplateNotificacao } from '../../types/templateNotificacao';

/**
 * Serviço para gerenciar templates de notificação personalizados
 * Data: 02/08/2025
 */
class TemplatesNotificacaoService {
  private baseURL: string;

  constructor() {
    this.baseURL = `${API_CONFIG.BASE_URL}/templates-notificacao`;
  }

  /**
   * Buscar templates do usuário logado
   */
  async buscarTemplates(): Promise<{ sucesso: boolean; dados?: TemplateNotificacao; mensagem: string }> {
    try {
      // console.log('[TemplatesService] Buscando templates do usuário...');
      
      const token = sessionStorage.getItem('token');
      if (!token) {
        throw new Error('Token de autenticação não encontrado');
      }

      const response = await fetch(`${this.baseURL}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.mensagem || `Erro ${response.status}: ${response.statusText}`);
      }

      const result = await response.json();
      
      // console.log('[TemplatesService] Templates carregados:', {
        // sucesso: result.sucesso,
        // temDados: !!result.dados,
        // timestamp: new Date().toISOString()
      // });

      return result;
    } catch (error) {
      console.error('[TemplatesService] Erro ao buscar templates:', error);
      return {
        sucesso: false,
        mensagem: error instanceof Error ? error.message : 'Erro desconhecido ao buscar templates'
      };
    }
  }

  /**
   * Salvar/atualizar templates do usuário
   */
  async salvarTemplates(templates: Partial<TemplateNotificacao>): Promise<{ sucesso: boolean; dados?: TemplateNotificacao; mensagem: string }> {
    try {
      // console.log('[TemplatesService] Salvando templates:', {
        // temEmailConfirmacao: !!templates.emailConfirmacaoHtml,
        // temEmailCancelamento: !!templates.emailCancelamentoHtml,
        // temCalendarTitulo: !!templates.calendarTituloTemplate,
        // timestamp: new Date().toISOString()
      // });
      
      const token = sessionStorage.getItem('token');
      if (!token) {
        throw new Error('Token de autenticação não encontrado');
      }

      const response = await fetch(`${this.baseURL}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(templates)
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.mensagem || `Erro ${response.status}: ${response.statusText}`);
      }

      const result = await response.json();
      
      // console.log('[TemplatesService] Templates salvos com sucesso:', {
        // timestamp: new Date().toISOString()
      // });

      return result;
    } catch (error) {
      console.error('[TemplatesService] Erro ao salvar templates:', error);
      return {
        sucesso: false,
        mensagem: error instanceof Error ? error.message : 'Erro desconhecido ao salvar templates'
      };
    }
  }

  /**
   * Restaurar templates padrão
   */
  async restaurarTemplatesPadrao(): Promise<{ sucesso: boolean; dados?: TemplateNotificacao; mensagem: string }> {
    try {
      // console.log('[TemplatesService] Restaurando templates padrão...');
      
      const token = sessionStorage.getItem('token');
      if (!token) {
        throw new Error('Token de autenticação não encontrado');
      }

      const response = await fetch(`${this.baseURL}/restaurar-padrao`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.mensagem || `Erro ${response.status}: ${response.statusText}`);
      }

      const result = await response.json();
      
      // console.log('[TemplatesService] Templates padrão restaurados:', {
        // timestamp: new Date().toISOString()
      // });

      return result;
    } catch (error) {
      console.error('[TemplatesService] Erro ao restaurar templates padrão:', error);
      return {
        sucesso: false,
        mensagem: error instanceof Error ? error.message : 'Erro desconhecido ao restaurar templates'
      };
    }
  }

  /**
   * Testar template com dados de exemplo
   */
  async testarTemplate(tipo: 'email' | 'calendar', template: string): Promise<{ sucesso: boolean; dados?: any; mensagem: string }> {
    try {
      // console.log('[TemplatesService] Testando template:', { tipo, tamanho: template.length });
      
      const token = sessionStorage.getItem('token');
      if (!token) {
        throw new Error('Token de autenticação não encontrado');
      }

      const response = await fetch(`${this.baseURL}/testar`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ tipo, template })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.mensagem || `Erro ${response.status}: ${response.statusText}`);
      }

      const result = await response.json();
      
      // console.log('[TemplatesService] Template testado:', {
        // sucesso: result.sucesso,
        // timestamp: new Date().toISOString()
      // });

      return result;
    } catch (error) {
      console.error('[TemplatesService] Erro ao testar template:', error);
      return {
        sucesso: false,
        mensagem: error instanceof Error ? error.message : 'Erro desconhecido ao testar template'
      };
    }
  }
}

export const templatesNotificacaoService = new TemplatesNotificacaoService();
